import { Text } from "@src/straps/base";
import classNames from "classnames";

type Variant = "card" | "page";

export default function PageNotAuthorized({
  pageName = "this page",
  reason,
  variant = "page",
}: {
  readonly pageName?: string;
  readonly reason: "account" | "permissions";
  readonly variant?: Variant;
}) {
  return (
    <div
      className={classNames(
        "flex w-full items-center justify-center overflow-auto",
        {
          "h-[calc(100vh-200px)] pb-16": variant === "page",
          "bg-white p-4": variant === "card",
        }
      )}
    >
      <div
        className={classNames("flex flex-col items-center", {
          "gap-8": variant === "page",
          "gap-4": variant === "card",
        })}
      >
        <LockIcon variant={variant} />
        <div className="flex flex-col items-center gap-1 text-center">
          <Text variant={variant === "page" ? "h2_t-30-700" : "h5_t-18-700"}>
            You don’t have access to {pageName}.
          </Text>
          <Text
            variant="sb_t-14-500"
            className={classNames({ "max-w-2xl": variant === "page" })}
          >
            {reason === "account" &&
              "This feature is only available to primary account users."}
            {reason === "permissions" &&
              "It looks like you don’t have the permissions needed to view this feature. If you believe you should have access, please contact your account administrator to update your permissions."}
          </Text>
        </div>
      </div>
    </div>
  );
}

function LockIcon({ variant }: { readonly variant: Variant }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={variant === "page" ? "190" : "95"}
      height={variant === "page" ? "190" : "95"}
      viewBox="0 0 190 190"
      fill="none"
    >
      <path
        d="M71.3247 97.1203L29 72.8604V165.74L71.3247 190V97.1203Z"
        fill="#003E42"
      />
      <path
        d="M71.3247 97.1204L29 72.8604L118.371 20.3906L160.706 44.6506L71.3247 97.1204Z"
        fill="#BBD1CF"
      />
      <path
        d="M160.706 137.851L71.3249 190V96.7893L160.706 44.6504V137.851Z"
        fill="#66A09B"
      />
      <path
        d="M54.493 76.8902C54.4729 76.7097 54.4629 76.5293 54.4629 76.3488C54.6132 63.9482 57.4102 51.7179 62.6732 40.4901C68.678 27.1572 77.4197 14.7164 89.6399 6.68654C95.6548 2.47612 102.792 0.150372 110.141 0C114.481 0.120298 118.732 1.28317 122.541 3.38838C126.341 5.49359 129.579 8.48098 131.985 12.0999C136.997 19.4982 138.811 28.5606 138.872 37.7233V38.1544C138.872 38.2747 138.842 38.3849 138.791 38.4952C138.19 41.0415 134.27 43.0064 129.529 43.0064C124.386 43.0064 120.205 40.6906 120.185 37.8336C119.534 32.2397 119.825 25.4931 115.093 20.8516C111.263 17.0923 104.707 19.3679 101.038 21.5633C100.316 21.9944 97.1384 24.2801 96.2863 24.9918C81.5699 37.4526 73.1491 57.1614 73.1491 76.8401H73.119C73.1391 76.9904 73.1491 77.1208 73.1491 77.2611C73.1491 80.1282 68.9587 82.4539 63.806 82.4539C58.6532 82.4539 54.4629 80.1282 54.4629 77.2611C54.4629 77.1308 54.4629 77.0005 54.493 76.8701V76.8902Z"
        fill="#66A09B"
      />
      <path
        d="M112.948 103.787L71.3249 128.067V137.38L112.948 113.09V103.787Z"
        fill="#BBD1CF"
      />
      <path
        d="M50.5235 115.927V125.24L71.3249 137.38V128.067L50.5235 115.927Z"
        fill="#66A09B"
      />
      <path
        d="M112.948 85.1104L71.3249 109.4V118.713L112.948 94.4234V85.1104Z"
        fill="#BBD1CF"
      />
      <path
        d="M50.5235 97.2607V106.564L71.3249 118.714V109.401L50.5235 97.2607Z"
        fill="#66A09B"
      />
    </svg>
  );
}
